import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Dashboard from '../dashboard/Dashboard';
import TVMode from '../tv/TVMode';
import { getCurrentUser, getUsers } from '../../actions/UsersActions';
import { initShoutoutsFeed, listenForShoutouts } from '../../actions/ShoutoutsActions';
import { getTags } from '../../actions/TagsActions';
import { getAchievements } from '../../actions/AchievementActions';
import { listenForComments, deleteComment, setShowDeleteComment } from '../../actions/CommentsActions';
import { setShowSendShoutoutModal, setShowSendShoutoutModalWithUser, setSendShoutoutModalProfileUser } from '../../actions/HotkeyActions';
import { setShowComments } from '../../actions/CommentsActions';
import { ToastContainer, toast, Slide } from 'react-toastify';
import SendShoutout from '../../components/SendShoutout';
import { Modal, ToastNotification, UserChip, PrismButton } from '../../components';
import AchievementNotification from '../../components/AchievementNotification';
import FullScreenImage from '../../components/FullScreenImage';
import { Icon } from '@material-ui/core';

class Home extends Component {

  constructor() {
    super();

    this.sendShoutoutByKey = this.sendShoutoutByKey.bind(this);
  }

  async UNSAFE_componentWillMount() {
    const { getCurrentUser, getUsers, initShoutoutsFeed, getTags, getAchievements, listenForComments, listenForShoutouts } = this.props;

    await getCurrentUser();
    await getUsers();
    await getTags();
    await initShoutoutsFeed();
    await getAchievements();
    listenForShoutouts();
    listenForComments();
    document.addEventListener('keyup', this.logKey);
    document.addEventListener('keyup', this.sendShoutoutByKey);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { newEarnedAchievement } = nextProps;
    const { history, currentUser } = this.props;

    if (newEarnedAchievement !== this.props.newEarnedAchievement) {
      toast(<AchievementNotification achievement={newEarnedAchievement} onClick={() => history.push(`/profile/${currentUser.uid}/achievements`)} />, {
        className: 'achievement-toast-background',
        progressClassName: 'achievement-toast-progress'
      });
    }
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src = "https://static.zdassets.com/ekr/snippet.js?key=ee13b32d-6beb-4b22-bc14-091a80a6f73f";
    document.head.appendChild(script);
  }

  sendShoutoutByKey(e) {
    const { history, profileUser, currentUser, showComments } = this.props;
    if (e.key === 's' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'INPUT'
      && e.target.id !== 'job-title' && e.target.id !== 'TVModeKey' && e.target.id !== 'bio-title'){
      if (showComments) {
        this.props.history.push('/shoutouts');
        this.props.setShowComments(null);
      }

      if (!this.props.isFocus) {
        // if we are on the shoutouts screen
        if (history.location.pathname === '/shoutouts') {
          if (document.documentElement.scrollTop > 215) {
            this.props.setShowSendShoutoutModal(true);
          } else {
            document.getElementsByClassName("send-shoutout-wrapper")[0].click();
          }
        } else {
          // if we are looking at a profile we need to check if its us
          if (profileUser && history.location.pathname.split('/')[1] === 'profile') {
            if (profileUser._id !== currentUser._id) {
              this.props.setShowSendShoutoutModalWithUser(true);
            } else {
              this.props.setShowSendShoutoutModal(true);
            }
          } else {
            this.props.setShowSendShoutoutModal(true);
          }
        }
      }
    }
  }

  handleDeleteComment(currentlySelectedComment) {
    const { currentUser } = this.props;
    if (currentUser._id === currentlySelectedComment.sender._id || currentUser.role === 'super_admin' || currentUser.role === 'admin') {
      this.props.deleteComment(currentlySelectedComment._id);
    }
  }

  renderSendShoutoutModal() {
    const { showSend } = this.props;
    if (window.innerWidth > 480) {
      return (
        <Modal style={{ overflow: 'visible' }} showModal={showSend} closeModal={() => this.props.setShowSendShoutoutModal(false)} width="80%">
          <SendShoutout modalMode onHeightChange={() => {}} startBig={true} onClose={() => this.props.setShowSendShoutoutModal(false)} test={showSend}/>
        </Modal>
      );
    } else {
      return (
        <Modal backdropClass="mobile-send-shoutout-modal" className="mobile-send-shoutout-modal" header="Send Shoutout"
          style={{ overflow: 'visible' }} showModal={showSend} closeModal={() => this.props.setShowSendShoutoutModal(false)} width="100%">
          <Icon onClick={() => this.props.setShowSendShoutoutModal(false)} className="back-arrow">arrow_right_alt</Icon>
          <SendShoutout modalMode onHeightChange={() => {}} startBig={true} onClose={() => this.props.setShowSendShoutoutModal(false)} test={showSend}/>
        </Modal>
      );
    }
  }

  renderDeleteCommentModal(currentlySelectedComment) {
    if (currentlySelectedComment) {
      const { text, sender } = currentlySelectedComment;
      return (
        <div style={{ backgroundColor: 'white', borderBottomLeftRadius: 19, borderBottomRightRadius: 19 }}>
          <div className="delete-confirmation-text">Are you sure you want to delete this comment?</div>
          <div className="delete-comment-preview">
            <div className="comment-from">
              <strong>From:</strong>
              <span style={{ marginRight: 8 }}>
                <UserChip user={sender} />
              </span>
            </div>
            <div style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: text }} />
          </div>
          <div className="delete-modal-buttons">
            <PrismButton
              style={{ backgroundColor: 'white', border: '1px solid #b1b0b0', color: '#4a4a4a' }}
              onClick={() => this.props.setShowDeleteComment(null)}
            >
              Cancel
            </PrismButton>
            <PrismButton onClick={() => this.handleDeleteComment(currentlySelectedComment)}>Yes</PrismButton>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderModals() {
    const { profileUser, showUser  } = this.props;
    return (
      <div>
        <Modal
          header="Delete Comment"
          className="delete"
          backdropClass="delete-backdrop"
          closeModal={() => this.props.setShowDeleteComment(null)}
          showModal={!!this.props.showDeleteComment}
        >
          {this.renderDeleteCommentModal(this.props.showDeleteComment)}
        </Modal>
        {this.renderSendShoutoutModal()}

        <Modal style={{ overflow: 'visible' }} showModal={showUser} closeModal={() => this.props.setShowSendShoutoutModal(false)} width="80%">
          <SendShoutout modalMode onHeightChange={() => {}} startWithUser={profileUser} onClose={() => this.props.setShowSendShoutoutModal(false)}/>
        </Modal>

      </div>
    );
  }

  render() {

    return (
      <div style={{ display: 'flex', flex: 1, width: '100%' }}>
        {this.renderModals()}
        <Switch>
          <Route exact path="/tv" component={TVMode} />
          <Route path="/" component={Dashboard} />
        </Switch>

        <ToastContainer closeButton={false} transition={Slide} autoClose={5000} pauseOnHover={true} />
        <FullScreenImage />
        <ToastNotification left={this.props.left} shown={this.props.shown}>{this.props.content}</ToastNotification>
        <ToastNotification
          left={false} shown={this.props.helpShown}
          style={{ bottom: 15 }}
          onClick={()=> window.zE('webWidget', 'toggle')}
        >
          <div className="help-button-content"> <Icon className="help-icon">help_outline</Icon><div className="help-button-text">HELP</div></div>
        </ToastNotification>
      </div>
    );
  }
}

const mapStateToProps = ({ achievementsStore, usersStore, hotkeyStore, commentsStore, toastStore }) => {
  const { newEarnedAchievement } = achievementsStore;
  const { currentUser } = usersStore;
  const { showComments, showDeleteComment } = commentsStore;
  const { isFocus, showSend, profileUser, showUser } = hotkeyStore;
  const { content, shown, left, helpShown } = toastStore;
  return { newEarnedAchievement, currentUser, showComments, showDeleteComment, isFocus, showSend, profileUser, showUser, content, shown, left, helpShown };
};

export default withRouter(connect(mapStateToProps, { getCurrentUser, getUsers, initShoutoutsFeed, getTags, getAchievements, deleteComment, setShowDeleteComment,
  listenForComments, listenForShoutouts, setSendShoutoutModalProfileUser, setShowSendShoutoutModal, setShowSendShoutoutModalWithUser, setShowComments })(Home));



// WEBPACK FOOTER //
// ./src/screens/home/Home.js